import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getExpertImage } from '../utils/expertImages';
import SafeImage from './SafeImage';

const ExpertCard = ({ expert, isFavorite = false, onToggleFavorite = () => {}, onBook = () => {}, bookHref = null, bookState = null, bookLabel = 'Đặt lịch' }) => {
  const navigate = useNavigate();

  return (
    <div className="expert-card">
      <div className="expert-image-container">
        <SafeImage
          src={getExpertImage(expert)}
          alt={expert.name || expert.specialty || 'Chuyên gia'}
          className="expert-image"
          nameForUiAvatar={expert.name}
          fallbackSrc={`https://ui-avatars.com/api/?name=${encodeURIComponent(expert.name || 'Expert')}&background=3b82f6&color=fff&size=80`}
        />
        <button
          className={`heart-btn ${isFavorite ? 'active' : ''}`}
          onClick={(ev) => { ev.stopPropagation(); onToggleFavorite(expert.id); }}
          aria-label={isFavorite ? 'Unfavorite' : 'Favorite'}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
              stroke={isFavorite ? "#EF4444" : "#6B7280"}
              fill={isFavorite ? "#EF4444" : "none"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="expert-info">
        <h3 className="expert-name expert-name-clickable" onClick={() => navigate(`/profile?expertId=${expert.id}`)}>
          {expert.name || (expert.specialties && expert.specialties[0]) || 'Chuyên gia'}
        </h3>

        <div style={{ marginTop: 8 }}>
          <span className="specialty-pill">
            {expert.specialties && expert.specialties.length ? expert.specialties.join(' · ') : (expert.specialty || 'kinh nghiệm')}
          </span>
        </div>

        <div style={{ marginTop: 10 }}>
          {expert.experience ? (
            <span className="years-pill">{expert.experience}{String(expert.experience).toString().includes('năm') ? '' : ' năm kinh nghiệm'}</span>
          ) : (
            <span style={{ color: '#92400e' }}>—</span>
          )}
        </div>

        <p className="description" style={{ marginTop: 12 }}>
          { (expert.qualifications && expert.qualifications.length > 0)
            ? expert.qualifications.join(' · ')
            : (expert.raw?.qualifications || expert.raw?.certifications || expert.raw?.degrees || expert.description || '') }
        </p>

        <div className="expert-footer">
          <div className="price-availability">
            <span className="price">{expert.price}</span>
            <span className="availability">{expert.availability}</span>
          </div>
          {bookHref ? (
            <Link to={bookHref} state={bookState} className="book-btn">{bookLabel}</Link>
          ) : (
            <button className="book-btn" onClick={() => onBook(expert)}>{bookLabel}</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpertCard;
